// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bloc-list .thumb {
  display: block;
  background-position: center;
  background-size: cover;
}
.bloc-list .thumb::before {
  content: "";
  display: block;
  padding-top: 60%;
}
.bloc-list .bloc-list-item {
  float: left;
  display: block;
}
.bloc-list .bloc-list-item a {
  position: relative;
  font-size: 20px;
}
.bloc-list .bloc-list-item a span {
  z-index: 12;
  position: relative;
}

@media only screen and (max-width: 991px) {
  .bloc-list {
    margin-top: 30px;
  }
  .bloc-list .bloc-list-item {
    width: 50% !important;
    padding: 0 15px;
    margin-bottom: 30px;
  }
  .bloc-list .bloc-list-item a span {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .bloc-list .thumb {
    display: block;
    background-position: center;
    background-size: cover;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
